// require('./bootstrap');

$(function () {
    $('input[name="proforma"]').on('change', function () {
        $(this).parent().addClass('mb-3');
        $('.reference-form').addClass('d-none');
    });

    $(document).on('click', '.add-period', function () {
        let period = $('.date-range .period:first-of-type');
        let newPeriod = period.clone();
        let index = $('.period').length + 1;

        newPeriod.find('input').each(function () {
            $(this).attr('name', $(this).data('question') + '[' + index + '][' + $(this).data('name') + ']').attr('value', '').prop('readonly', false).removeAttr('id');
        });

        newPeriod.find('label').hide();
        newPeriod.find('.add button').removeClass('add-period').addClass('remove-period').find('i').removeClass('fa-plus').addClass('fa-trash');

        $('.date-range').append(newPeriod[0].outerHTML);
    });

    $(document).on('click', '.remove-period', function () {
        $(this).parents('.period').remove();
    });

    // remove validation error feedback from a field
    $('body').on('keyup', '.is-invalid', function () {
        $(this).removeClass('is-invalid');
    });
    $('body').on('change', 'select.is-invalid', function () {
        $(this).removeClass('is-invalid');
    });

    $(document).on('click', '.present-checkbox .present input', function () {
        let period = $('.date-range-separate .date-range-separate-inner:first .row:first');
        period.find('*[data-name="[to][d]"]:first').val('').removeClass('is-invalid').prop('readonly', $(this).is(":checked"));
        period.find('*[data-name="[to][m]"]:first').val('').removeClass('is-invalid').prop('readonly', $(this).is(":checked"));
        period.find('*[data-name="[to][y]"]:first').val('').removeClass('is-invalid').prop('readonly', $(this).is(":checked"));
    });

    $(document).on('click', '.add-period-separate', function () {
        let period = $('.date-range-separate .date-range-separate-inner:first .row:first');
        let newPeriod = period.clone();
        let innerWrapper = $('.date-range-separate-inner');
        let index = parseInt($('.row-instance:last input:first').attr('data-index')) + 1;

        newPeriod.find('input').each(function () {
            $(this).attr('name', $(this).data('question') + '[' + index + ']' + $(this).data('name'))
                .val('')
                .removeClass('is-invalid')
                .attr('data-index', index)
                .prop('readonly', false);
        });

        newPeriod.find('label').addClass('d-sm-none');
        newPeriod.find('.present-checkbox').html('').append(newPeriod.find('label').clone().text('To'));
        newPeriod.find('.add').removeClass('mt-xl-4');
        newPeriod.find('.add button')
            .prop('title', 'Click here to remove this date range')
            .removeClass('add-period-separate')
            .addClass('remove-period-separate')
            .find('i').removeClass('fa-plus').addClass('fa-trash');

        innerWrapper.append(newPeriod);
    });

    $(document).on('click', '.remove-period-separate', function () {
        $(this).parents('.row:first').remove();
    });
});

